/* eslint-disable promise/always-return,promise/catch-or-return */
import { useEffect, useState, useRef } from 'react';
import { PROGRESS_STEPS, TEST_STEPS } from '../constants';

const QUALITY_PROGRESS = 5;

const getSessionInfo = (credentials, devices) => {
  if (!credentials) return null;
  const { apiKey, token, room: sessionId } = credentials;
  return {
    sessionInfo: {
      apiKey,
      sessionId,
      token,
    },
    options: {
      timeout: 20000,
      ...devices,
    },
  };
};

export function useTestCall(step, testCredentials, devices) {
  const mountedRef = useRef(true);
  const otNetworkTest = useRef(null);
  const [canCancel, setCancelStatus] = useState(false);
  const [progress, setProgress] = useState(PROGRESS_STEPS.INIT);
  const [results, setResults] = useState(null);
  const [disabled, toggleDisableStatus] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [testError, setError] = useState(null);

  useEffect(() => {
    return () => {
      stopTest();
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (testCredentials && step === TEST_STEPS.PROGRESS) {
      if (results) setResults(null);
      if (notFound) setNotFound(false);
      mountedRef.current = true;
      const { sessionInfo, options } = getSessionInfo(testCredentials, devices);
      otNetworkTest.current = new OpenTokNetworkConnectivity.default(
        OT,
        sessionInfo,
        options,
      );
      setProgress(PROGRESS_STEPS.START);

      otNetworkTest.current.testConnectivity().then(res => {
        if (!mountedRef.current) return null;
        if (res.success) {
          setProgress(PROGRESS_STEPS.CONNECTION_TEST_PASSED);
          setCancelStatus(true);
          testQuality();
        } else {
          convertErrors(res.failedTests);
          stopTest();
        }
      });
    }
  }, [testCredentials, step]);

  useEffect(() => {
    if (canCancel) {
      const timer = setTimeout(() => {
        toggleDisableStatus(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [canCancel]);

  function testQuality() {
    otNetworkTest.current
      .testQuality(function updateCallback(stats) {
        if (!mountedRef.current) return null;
        setProgress(prevState => {
          if (prevState < PROGRESS_STEPS.QUALITY_LIMIT) {
            return prevState + QUALITY_PROGRESS;
          }
          return prevState;
        });
      })
      .then(res => {
        if (!mountedRef.current) return null;
        setResults(res);
        setProgress(PROGRESS_STEPS.DONE);
      });
  }

  function stopTest() {
    if (otNetworkTest.current) {
      otNetworkTest.current.stop();
      setProgress(PROGRESS_STEPS.INIT);
      mountedRef.current = false;
    }
  }

  function convertErrors(errs) {
    const errorNames = errs.map(item => item.error.name);
    if (
      errorNames.includes(
        OpenTokNetworkConnectivity.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER,
      )
    ) {
      setNotFound(true);
    } else {
      setError('errors.common');
    }
  }

  return {
    disabled,
    progress,
    results,
    stopTest,
    notFound,
    error: testError,
  };
}



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/utils/useTestCall.js